import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const LazyImageContext = /*#__PURE__*/createContext(undefined);
export function LazyImageProvider({
  children
}) {
  return /*#__PURE__*/_jsx(LazyImageContext.Provider, {
    value: "lazy",
    children: children
  });
}
export function useLazyImage() {
  return useContext(LazyImageContext);
}